import type { IPopupConfig } from "@similarweb/ui-components";
import { PopupHoverContainer } from "@similarweb/ui-components";
import classNames from "classnames";
import React from "react";
import type { ReactNode } from "react";
import { PlainTooltipContent } from "./PlainTooltipContent";

interface IPlainTooltipProps {
    text: ReactNode;
    enabled?: boolean;
    placement?: string;
    cssClass?: string;
    cssClassContent?: string;
    maxWidth?: number;
    defaultOpen?: boolean;
    dangerouslySetInnerHTML?: boolean;
    variation?: string;
    closePopupOnClick?: boolean;
    autoPlacement?: boolean;
    children?: ReactNode;
}

/**
 * a Tooltip that just shows text
 */
export class PlainTooltip extends React.Component<IPlainTooltipProps> {
    public static defaultProps = {
        text: "MISSING_TEXT",
        cssClass: "plainTooltip-element",
        cssClassContent: "plainTooltip-content",
        enabled: true,
        placement: "top",
        variation: "normal",
        maxWidth: 250,
        dangerouslySetInnerHTML: false,
        closePopupOnClick: false,
        autoPlacement: true,
    };

    public render() {
        const config: IPopupConfig = {
            enabled: this.props.enabled,
            placement: this.props.placement,
            autoPlacement: this.props.autoPlacement,
            maxWidth: this.props.maxWidth,
            cssClass: this.props.cssClass,
            cssClassContent: this.props.cssClassContent,
            cssClassContainer: "",
        };
        if (this.props.variation === "white") {
            config.cssClass = classNames(this.props.cssClass, "plainTooltip-element plainTooltip-element-white");
        }
        return (
            <PopupHoverContainer
                debounce={400}
                content={() => (
                    <PlainTooltipContent
                        text={this.props.text}
                        dangerouslySetInnerHTML={this.props.dangerouslySetInnerHTML}
                    />
                )}
                config={config}
                closePopupOnClick={this.props.closePopupOnClick}
            >
                {this.props.children}
            </PopupHoverContainer>
        );
    }
}
